<div class="center-stage">
  <div class="spinner">
    <div class="rect1">&nbsp;</div>
    <div class="rect2">&nbsp;</div>
    <div class="rect3">&nbsp;</div>
    <div class="rect4">&nbsp;</div>
    <div class="rect5">&nbsp;</div>
  </div>
</div>
